import { jsx as _jsx } from "react/jsx-runtime";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import { AccordionSummary, styled } from "@mui/material";
export const StyledAccordionSummary = styled(AccordionSummary)(({ theme }) => {
    return {
        px: 4,
        "& .MuiAccordionSummary-content": {
            width: 1,
        },
    };
});
StyledAccordionSummary.defaultProps = {
    expandIcon: _jsx(ExpandMoreIcon, {}),
    className: "accordion-summary-background",
};
